import { useEffect, useState } from "react";
import axios from "axios";

import { useTranslation } from "react-i18next";

function AdminClassAnalytics() {

  const token = localStorage.getItem("access");

  const [classes, setClasses] = useState([]);
  const { t } = useTranslation();

  const [terms, setTerms] = useState([]);

  const [assessmentTypes, setAssessmentTypes] = useState([]);

  const [selectedClass, setSelectedClass] = useState("");

  const [selectedTerm, setSelectedTerm] = useState("");

  const [selectedAssessment, setSelectedAssessment] = useState("");
  const [message, setMessage] = useState("");

  const [analytics, setAnalytics] = useState(null);

  // =====================================================
  // LOAD INITIAL DATA
  // =====================================================

  useEffect(() => {

    fetchClasses();

    fetchTerms();

    fetchAssessmentTypes();

  }, []);

  // =====================================================
  // FETCH CLASSES
  // =====================================================

  const fetchClasses = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/academics/classes/",
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );

      setClasses(res.data);

    } catch (err) {

      console.error(err);
    }
  };

  // =====================================================
  // FETCH TERMS
  // =====================================================

  const fetchTerms = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/results/active-terms/",
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );

      setTerms(res.data);

    } catch (err) {

      console.error(err);
    }
  };

  // =====================================================
  // FETCH ASSESSMENT TYPES
  // =====================================================

  const fetchAssessmentTypes = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/results/assessment-types/",
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );

      setAssessmentTypes(res.data);

    } catch (err) {

      console.error(err);
    }
  };

  // =====================================================
  // FETCH ANALYTICS
  // =====================================================

  const fetchAnalytics = async () => {

    if (
      !selectedClass ||
      !selectedTerm ||
      !selectedAssessment
    ) {
      alert("Please select all fields.");
      return;
    }

    try {

      const res = await axios.get(
        `https://api.eduskot.com/api/results/class-analytics/?class_id=${selectedClass}&term_id=${selectedTerm}&assessment_type_id=${selectedAssessment}`,
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );

      if (
  !res.data.subject_analysis?.length &&
  !res.data.student_results?.length
) {

  setAnalytics(null);

  setMessage(
    "No marks have been entered for this Class, Term and Sequence."
  );

  return;
}

setMessage("");

setAnalytics(res.data);

    } catch (err) {

      console.error(err);

      setAnalytics(null);

      setMessage(
        err.response?.data?.error ||
        "No results available for the selected filters."
      );
    }
  };

  const printAnalytics = () => {

  const printContents =
    document.getElementById(
      "analytics-report"
    ).innerHTML;

  const win = window.open(
    "",
    "",
    "width=1200,height=900"
  );

  win.document.write(`
    <html>
    <head>
      <title>Class Analytics</title>

      <style>

      body{
        font-family:Arial;
        padding:30px;
      }

      table{
        width:100%;
        border-collapse:collapse;
      }

      th,td{
        border:1px solid #000;
        padding:8px;
      }

      th{
        background:#e2e8f0;
      }

      h2,h3{
        margin-bottom:15px;
      }

      </style>

    </head>

    <body>

      ${printContents}

    </body>

    </html>
  `);

  win.document.close();

  win.print();

};

  return (

    <div style={styles.page}>

      {/* HEADER */}

      <div style={styles.header}>

        <div style={{display:"flex",gap:"10px"}}>

  <button
    style={styles.printBtn}
    onClick={printAnalytics}
  >
    Print Report
  </button>

  <button
    style={styles.backBtn}
    onClick={() =>
      window.location.href =
      "/admin-dashboard"
    }
  >
    {t("back")}
  </button>

</div>

      </div>

      {/* FILTERS */}

      <div style={styles.filterCard}>

        <select
          value={selectedClass}
          onChange={(e)=>
            setSelectedClass(e.target.value)
          }
          style={styles.select}
        >

          <option value="">
            Select Class
          </option>

          {classes.map((c)=>(

            <option key={c.id} value={c.id}>
    {c["department__name"]
        ? `${c.name} (${c["department__name"]})`
        : c.name}
</option>

          ))}

        </select>

        <select
          value={selectedTerm}
          onChange={(e)=>
            setSelectedTerm(e.target.value)
          }
          style={styles.select}
        >

          <option value="">
            Select Term
          </option>

          {terms.map((t)=>(

            <option
              key={t.id}
              value={t.id}
            >
              {t.name}
            </option>

          ))}

        </select>

        <select
          value={selectedAssessment}
          onChange={(e)=>
            setSelectedAssessment(e.target.value)
          }
          style={styles.select}
        >

          <option value="">
            Select Sequence
          </option>

          {assessmentTypes.map((a)=>(

            <option
              key={a.id}
              value={a.id}
            >
              {a.name}
            </option>

          ))}

        </select>

        <button
          style={styles.generateBtn}
          onClick={fetchAnalytics}
        >
          Generate Analytics
        </button>

      </div>

      {/* ANALYTICS */}

      {message && (

  <div
    style={{
      background:"#fef3c7",
      color:"#92400e",
      padding:"15px",
      borderRadius:"10px",
      marginBottom:"20px",
      border:"1px solid #fcd34d",
      textAlign:"center",
      fontWeight:"600"
    }}
  >
    {message}
  </div>

)}

      {analytics && (

        <div
          id="analytics-report"
          style={styles.analyticsCard}
        >

          <h2 style={styles.sectionTitle}>
            {analytics.class}
          </h2>

          <p style={styles.subTitle}>
            {analytics.term}
            {" • "}
            {analytics.assessment}
          </p>

          {/* SUMMARY */}

          <div style={styles.statsGrid}>

            <div style={styles.statBox}>
              <h3>{t("classAverage")}</h3>
              <p>{analytics.class_average}</p>
            </div>

            <div style={styles.statBox}>
              <h3>{t("highestScore")}</h3>
              <p>{analytics.highest_score}</p>
            </div>

            <div style={styles.statBox}>
              <h3>{t("lowestScore")}</h3>
              <p>{analytics.lowest_score}</p>
            </div>

            <div style={styles.statBox}>
              <h3>{t("passRate")}</h3>
              <p>{analytics.pass_rate}%</p>
            </div>

            <div style={styles.statBox}>
              <h3>{t("failRate")}</h3>
              <p>{analytics.fail_rate}%</p>
            </div>

            <div style={styles.statBox}>
              <h3>{t("bestStudent")}</h3>
              <p>{analytics.best_student}</p>
            </div>

          </div>

          

          {/* SUBJECT TABLE */}

          <h3 style={styles.subjectTitle}>
            {t("subjectPerformanceAnalysis")}
          </h3>

          <table style={styles.table}>

            <thead>

              <tr>

                <th style={styles.th}>
                  Subject
                </th>

                <th style={styles.th}>
                  Average
                </th>

                <th style={styles.th}>
                  Highest
                </th>

                <th style={styles.th}>
                  Lowest
                </th>

                <th style={styles.th}>
                  Pass Rate
                </th>

              </tr>

            </thead>

            <tbody>

              {analytics.subject_analysis?.map(
                (subject,index)=>(

                <tr key={index}>

                  <td style={styles.td}>
                    {subject.subject}
                  </td>

                  <td style={styles.centerTd}>
                    {subject.average}
                  </td>

                  <td style={styles.centerTd}>
                    {subject.highest}
                  </td>

                  <td style={styles.centerTd}>
                    {subject.lowest}
                  </td>

                  <td style={styles.centerTd}>
                    {subject.pass_rate}%
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

          {/* STUDENT RESULTS TABLE */}

<h3
style={{
    marginTop:"40px",
    marginBottom:"20px"
}}
>
{t("studentSequencePerformance")}
</h3>

<div style={{ overflowX:"auto" }}>

<table style={styles.table}>

    <thead>

    <tr>

        <th style={styles.th}>
        Student Name
        </th>

        {analytics.student_results?.length > 0 &&

        Object.keys(
            analytics.student_results[0]
        )
        .filter(
            (key)=>
            ![
                "student",
                "average",
                "position"
            ].includes(key)
        )
        .map((subject,index)=>(

            <th
            key={index}
            style={styles.th}
            >
            {subject}
            </th>

        ))}

        <th style={styles.th}>
        Average
        </th>

        <th style={styles.th}>
        Position
        </th>

    </tr>

    </thead>

    <tbody>

    {analytics.student_results?.length > 0 &&
  analytics.student_results.map(
        (student,index)=>(

        <tr key={index}>

            <td style={styles.td}>
            {student.student}
            </td>

            {Object.keys(student)
            .filter(
                (key)=>
                ![
                    "student",
                    "average",
                    "position"
                ].includes(key)
            )
            .map((subject,i)=>(

                <td
                key={i}
                style={styles.centerTd}
                >
                {student[subject]}
                </td>

            ))}

            <td style={styles.centerTd}>
            {student.average}
            </td>

            <td style={styles.centerTd}>
            {student.position}
            </td>

        </tr>

    ))}

    </tbody>

</table>

</div>

        </div>
      )}

    </div>
  );
}

const styles = {

  page:{
    minHeight:"100vh",
    padding:"8px",
    background:"#f1f5f9",
    fontFamily:"Segoe UI"
  },

  header:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    marginBottom:"30px",
    flexWrap:"wrap",
    gap:"10px"
  },

  filterCard:{
    background:"white",
    padding:"25px",
    borderRadius:"14px",
    marginBottom:"30px",
    boxShadow:"0 10px 25px rgba(0,0,0,0.08)",
    display:"grid",
    gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",
    gap:"15px"
  },

  analyticsCard:{
    background:"white",
    padding:"30px",
    borderRadius:"14px",
    boxShadow:"0 10px 25px rgba(0,0,0,0.08)"
  },

  select:{
    padding:"14px",
    borderRadius:"10px",
    border:"1px solid #cbd5e1"
  },

  generateBtn:{
    padding:"14px",
    background:"#2563eb",
    color:"white",
    border:"none",
    borderRadius:"10px",
    fontWeight:"600",
    cursor:"pointer"
  },

  backBtn:{
    padding:"10px 18px",
    border:"none",
    borderRadius:"10px",
    background:"#2563eb",
    color:"white",
    cursor:"pointer"
  },

  printBtn:{
  padding:"10px 18px",
  border:"none",
  borderRadius:"10px",
  background:"#16a34a",
  color:"white",
  cursor:"pointer"
},

  sectionTitle:{
    marginBottom:"8px"
  },

  subTitle:{
    color:"#64748b",
    marginBottom:"25px"
  },

  statsGrid:{
    display:"grid",
    gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",
    gap:"20px",
    marginBottom:"30px"
  },

  statBox:{
    background:"#f8fafc",
    padding:"20px",
    borderRadius:"12px",
    textAlign:"center",
    border:"1px solid #e2e8f0"
  },

  commentBox:{
    background:"#eff6ff",
    padding:"20px",
    borderRadius:"12px",
    marginBottom:"30px"
  },

  subjectTitle:{
    marginBottom:"20px"
  },

  table:{
    width:"100%",
    borderCollapse:"collapse"
  },

  th:{
    border:"1px solid #000",
    padding:"12px",
    background:"#e2e8f0",
    textAlign:"center"
  },

  td:{
    border:"1px solid #000",
    padding:"10px"
  },

  centerTd:{
    border:"1px solid #000",
    padding:"10px",
    textAlign:"center"
  }
};

export default AdminClassAnalytics;